/* eslint-disable camelcase */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async resendVerificationMobile(_, mobile) {
      return await window.$axios.post('self/mobile-verify');
    },
    async checkMail(_, { email }) {
      return await window.$axios.post('check-email', {
        email,
      });
    },
    async checkUserNationByUrl(_) {
      return await window.$axios.get('user-locale');
    },
    async fastRegister(_, { company_type_id, email, ref, mobile, payment_intent_client_secret, lang }) {
      return $axios.post('fast/register', {
        company_type_id,
        email,
        ref,
        mobile,
        payment_intent_client_secret,
        lang,
      });
    },
    async mobileVerify(_, { mobile, code }) {
      return await window.$axios.put('self/mobile-verify', {
        mobile,
        code,
      });
    },
  },
});
